module.exports = __webpack_public_path__ + "r4-31e22ac4.webp";